<template>
  <el-dialog
    :class="['dialog-item',className]"
    :visible="_visible"
    :title="title"
    center
    top="240px"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="closeEscape"
    :show-close="showClose"
    @close="close"
  >
    <slot />
    <span
      v-if="!noButton"
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="button.left"
        class="btn cancel-btn"
        :disabled="leftDisabled"
        @click="cancel"
      >{{ button.left }}</el-button>
      <el-button
        v-if="button.right"
        :disabled="disabled"
        type="primary"
        class="btn comfirm-btn"
        :loading="loading"
        @click="comfirm"
      >{{ button.right }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MessageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '这是标题'
    },
    width: {
      type: String, // 弹窗的宽度
      default: '360px'
    },
    noButton: {
      type: Boolean,
      default: false
    },
    button: {
      type: Object,
      default: function() {
        return {
          disabled: false,
          left: '取消', // 不传则不显示该按钮，通过按钮文案是否传参，控制单双按钮显示
          right: '确认'
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    leftDisabled: {
      typel: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    _visible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('close', val)
      }
    },
    className() {
      return this.noButton ? 'no-button' : ''
    }
  },
  created() {},
  mounted() {},

  methods: {
    close() {
      this._visible = false
    },
    cancel() {
      this._visible = false
      this.$emit('cancel')
    },
    comfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep.dialog-item {
  .el-dialog__header {
    text-align: center;
    padding: 20px;
    border-bottom: 1px solid #f3efef;
  }
  .el-dialog__body {
    padding: 24px 32px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .el-dialog__footer {
    display: flex;
    height: 80px;
    padding: 24px 31px;
    text-align: center;
    border-top: 1px solid #f3efef;
  }
  .dialog-footer {
    width: 100%;
    display: flex;
    .btn {
      flex: 1;
      height: 32px;
      border-radius: 18px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .comfirm-btn {
      background: #1fa0e8;
    }
    .comfirm-btn.is-disabled {
      background: #ccc;
      border: 1px solid #ccc;
    }
    .el-button {
      padding: 0;
    }
  }
}
::v-deep.no-button {
  .el-dialog__body {
    padding: 24px 32px 60px;
  }
}
</style>
